import SidebarContext from 'state/SidebarContext';
import { useContext } from 'react';

const ContactSeller = () => {
    const { uiText } = useContext(SidebarContext);
    const { text } = uiText.sections.sidebar.contactSeller;
    return (
        <section
            className="border border-bluegray-200 rounded-8 p-24 mt-24"
            aria-label="Kontakt selger"
        >
            <p className="text-14 mb-14">{text}</p>
            <finn-contact-button
                id="finn-contact-button"
                textAlignButton="START"
                hasButtonIcon="true"
            ></finn-contact-button>
        </section>
    );
};

export default ContactSeller;
